import { useState } from 'react';

import type { RecentContract, RecentSearch } from '../types';
import {
  addRecentContractToStorage,
  addRecentSearchToStorage,
  getRecentContractsFromStorage,
  getRecentSearchesFromStorage,
  removeRecentContractFromStorage,
  removeRecentSearchFromStorage,
} from '../utils/recent-storage';

export const useRecentStorage = (username: string) => {
  const [recentSearches, setRecentSearches] = useState<RecentSearch[]>(getRecentSearchesFromStorage(username));
  const [recentContracts, setRecentContracts] = useState<RecentContract[]>(getRecentContractsFromStorage(username));

  const addRecentSearch = (searchQuery: string) => {
    addRecentSearchToStorage(username, searchQuery);
    setRecentSearches(getRecentSearchesFromStorage(username));
  };

  const addRecentContract = (contract: Omit<RecentContract, 'visitedAt'>) => {
    addRecentContractToStorage(username, contract);
    setRecentContracts(getRecentContractsFromStorage(username));
  };

  const removeRecentSearch = (searchQuery: string) => {
    removeRecentSearchFromStorage(username, searchQuery);
    setRecentSearches((prev) => prev.filter((item) => item.query !== searchQuery));
  };

  const removeRecentContract = (contractId: string) => {
    removeRecentContractFromStorage(username, contractId);
    setRecentContracts((prev) => prev.filter((item) => item.id !== contractId));
  };

  return {
    recentSearches,
    recentContracts,
    addRecentSearch,
    addRecentContract,
    removeRecentSearch,
    removeRecentContract,
  };
};
